import { useEffect, useRef, useState } from 'react'
import { Button, Container, Row, Spinner } from 'react-bootstrap'
import { useNavigate, useOutletContext } from 'react-router-dom'
import OtpInput from 'react-otp-input'
import loginStep2 from 'assets/images/login-step2.svg'
import { useTranslation } from 'react-i18next'
import { useAtom } from 'jotai'
import { mobilePageTitleAtom } from 'config/store'
import { useLoginSMS, useRequestOTP } from 'dataLayer/user'
import { PATHS } from 'config/routes'
import { useDispatch, useSelector } from 'react-redux'
import { curState } from 'store/selector'
import { showSnackbar } from 'store/actions'

function OTPConfirmMobile({ title }) {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const selector = useSelector(curState)
	const { phone } = useOutletContext()

	const [, setMobilePageTitle] = useAtom(mobilePageTitleAtom)
	useEffect(() => {
		setMobilePageTitle(title)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	const dispatch = useDispatch()

	const [otp, setOtp] = useState('')
	useEffect(() => {
		setOtp('')
	}, [title])
	const handleChangeOtp = otp => {
		setOtp(otp)
	}

	const errorRef = useRef(null)
	const { mutate, data, isLoading } = useLoginSMS(
		() => navigate(PATHS.HOME_PAGE),
		() => {
			if (errorRef.current) {
				errorRef.current.innerText = data?.message
			}
		},
	)
	useEffect(() => {
		if (errorRef.current) {
			errorRef.current.innerText = ''
		}
	}, [])

	function handleLogin() {
		mutate({
			msisdn: phone,
			otp: otp,
			grant_type: 'login_with_sms',
		})
	}
	const { mutate: fnLogin } = useRequestOTP(
		data => {
			dispatch(showSnackbar(true, t('modal.success'), 'success'))
		},
		error => {
			dispatch(showSnackbar(true, error?.message || t('modal.error'), 'error'))
		},
	)
	const handleResend = () => {
		fnLogin({ msisdn: selector.phone })
	}

	return (
		<Container className="login-mobile login-otp" fluid>
			<Row>
				<img
					src={loginStep2}
					alt="Login step 2"
					className="login-step mx-auto mb-3"
				/>
				<p>{t('modal.login.otp_sendtophone').replace('_PHONE_', phone)}</p>
			</Row>
			<Row>
				<OtpInput
					containerStyle="otp-group"
					inputStyle="otp-input"
					value={otp}
					onChange={handleChangeOtp}
					numInputs={6}
					isInputNum={true}
				/>
				{parseInt(data?.responseCode) === 403 ? (
					<p className="error-otp" ref={errorRef}>
						{data?.message}
					</p>
				) : null}
			</Row>
			<Button variant="secondary" onClick={handleLogin} disabled={isLoading}>
				{t('modal.login.otp_confirm')}
				{isLoading ? (
					<Spinner animation="border" role="status"></Spinner>
				) : null}
			</Button>
			<Row>
				<p className="otp-resend">
					{t('modal.login.otp_notreceived')}{' '}
					<a onClick={handleResend}>{t('modal.login.otp_resend')}</a>
				</p>
			</Row>
		</Container>
	)
}

export default OTPConfirmMobile
